var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61905 8.30453C10.0333 8.30453 10.369 7.96874 10.369 7.55453C10.369 7.14031 10.0333 6.80453 9.61905 6.80453V8.30453ZM6.19048 12.4946C5.77626 12.4946 5.44048 12.8304 5.44048 13.2446C5.44048 13.6588 5.77626 13.9946 6.19048 13.9946V12.4946ZM7.15529 7.55499C7.15529 7.9692 7.49108 8.30499 7.90529 8.30499C8.3195 8.30499 8.65529 7.9692 8.65529 7.55499H7.15529ZM8.65529 6.3999C8.65529 5.98569 8.3195 5.6499 7.90529 5.6499C7.49108 5.6499 7.15529 5.98569 7.15529 6.3999H8.65529ZM7.15529 14.3999C7.15529 14.8141 7.49108 15.1499 7.90529 15.1499C8.3195 15.1499 8.65529 14.8141 8.65529 14.3999H7.15529ZM8.65529 13.2448C8.65529 12.8306 8.3195 12.4948 7.90529 12.4948C7.49108 12.4948 7.15529 12.8306 7.15529 13.2448H8.65529ZM9.61905 6.80453H7.23809V8.30453H9.61905V6.80453ZM7.2381 11.2634H8.85714V9.76335H7.2381V11.2634ZM9.25 11.879C9.25 12.0889 9.17843 12.2577 9.0901 12.3632C9.00312 12.4672 8.91765 12.4946 8.85714 12.4946V13.9946C10.0221 13.9946 10.75 12.9167 10.75 11.879H9.25ZM8.85714 11.2634C8.91765 11.2634 9.00312 11.2907 9.09011 11.3947C9.17843 11.5002 9.25 11.669 9.25 11.879H10.75C10.75 10.8412 10.0221 9.76335 8.85714 9.76335V11.2634ZM5.25 9.03394C5.25 10.1346 6.02055 11.2634 7.2381 11.2634V9.76335C7.08808 9.76335 6.75 9.56742 6.75 9.03394H5.25ZM7.23809 6.80453C6.02055 6.80453 5.25 7.9333 5.25 9.03394H6.75C6.75 8.50046 7.08807 8.30453 7.23809 8.30453V6.80453ZM8.65529 7.55499V6.3999H7.15529V7.55499H8.65529ZM8.65529 14.3999V13.2448H7.15529V14.3999H8.65529ZM8.85714 12.4946H7.52381V13.9946H8.85714V12.4946ZM7.52381 12.4946H6.19048V13.9946H7.52381V12.4946Z",
    fill: "#054BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 8.7998H21.2002",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 12H21.2002",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1727 23.2001H2.36383C2.05522 23.2001 1.75924 23.0967 1.54102 22.9125C1.32279 22.7284 1.2002 22.4787 1.2002 22.2183V2.58192C1.2002 2.32152 1.32279 2.07179 1.54102 1.88767C1.75924 1.70354 2.05522 1.6001 2.36383 1.6001H25.6366C25.9452 1.6001 26.2412 1.70354 26.4594 1.88767C26.6776 2.07179 26.8002 2.32152 26.8002 2.58192V15.9207C26.8002 16.0496 26.7701 16.1773 26.7116 16.2964C26.6531 16.4155 26.5674 16.5238 26.4594 16.6149L18.9956 22.9125C18.8875 23.0037 18.7592 23.076 18.6181 23.1254C18.4769 23.1747 18.3256 23.2001 18.1727 23.2001V23.2001Z",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8003 16H18.8003V22.75",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.b6a262518d19b1a726eeacff54733f31.svg";
export { ForwardRef as ReactComponent };